<template>
</template>

<script>

import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
import {poolData} from '@/shared/aws-settings'

export default {
  name: 'Sign Out',

  created () {
      var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

      var cognitoUser = userPool.getCurrentUser();

      if (cognitoUser != null) {
          cognitoUser.signOut();
      }

      this.$router.push({name: "Sign In"});

  }

}
</script>
